e4.gtm = {
    debug: false,
    init: function () {
        if ( window.dataLayer !== undefined ) {
            e4.gtm.bindEvents();
        }
        else {
            e4.util.debug( ['window.google_tag_manager = ', window.google_tag_manager, 'Not binding anything.'], e4.gtm.debug );
        }
    },
    bindEvents: function () {
        jQuery( document )
        .on( 'userauthenticated.e4.login', e4.gtm.login )
        .on( 'productadded.e4.cart', e4.gtm.ecom.addProduct )
        .on( 'orderlinedeleted.e4.cart', e4.gtm.ecom.removeProduct );
        jQuery( '.js-e-search-form' )
        .on( 'loaded.e4.search', e4.gtm.search );
        jQuery( '.js-e-checkout, .js-e-checkout-receipt' )
        .on( ['stepchanged.e4.checkout', 'receiptshown.e4.checkout'].join( ' ' ), e4.gtm.ecom.checkoutStep );
        jQuery( '.js-e-dealersearch' )
        .on( 'searchbyaddress.e4.dealersearch', e4.gtm.dealersearch.searchByAddress )
        .on( 'markerclicked.e4.dealersearch', e4.gtm.dealersearch.markerClicked )
        .on( 'geolocationerror.e4.dealersearch', e4.gtm.dealersearch.geolocationError )
        .on( 'maperror.e4.dealersearch', e4.gtm.dealersearch.mapError );
    },
    pushDataLayer: function ( objDataLayer ) {
        if ( window.dataLayer !== undefined ) {
            dataLayer.push( objDataLayer );
        }
        else {
            e4.util.debug( ['window.dataLayer = ', window.dataLayer, 'Not pushing anything.'], e4.gtm.debug );
        }
    },
    login: function () {
        e4.gtm.pushDataLayer( {
            'LoggedOn': 'OK',
            'event': 'LoggedOnDone'
        } );
    },
    search: function ( event, objData ) {
        e4.gtm.pushDataLayer( {
            'event': 'VirtualPageviewSearch',
            'virtualPageSearchURL': '/search?q=' + objData.query,
            'virtualPageSearchTitle': 'Search'
        } );
        if ( objData.resultCount === 0 ) {
            e4.gtm.pushDataLayer( {
                'eventCategory': 'Search - Zero results',
                'eventAction': objData.query,
                'eventLabel': '{{Page URL}}',
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
        }
    }
}